
/**
 * 응답 데이터
 */
export type NicePayBillingCallback200Data = { [key: string]: unknown };
